module.exports = __webpack_public_path__ + "assets/units/avatars/Vertigo.jpg";